import { render } from "./TabPills.vue?vue&type=template&id=e06a6a10"
import script from "./TabPills.vue?vue&type=script&lang=js"
export * from "./TabPills.vue?vue&type=script&lang=js"
script.render = render

export default script